import React from 'react';
import StylishNewSelect from 'components/DesignSystems/New/StylishNewSelect';

type AgentMode = 'ask' | 'agent_auto' | 'agent_confirm';

type ModeOption = {
  value: AgentMode;
  label: string;
};

const MODE_OPTIONS: ModeOption[] = [
  { value: 'ask', label: 'Ask' },
  { value: 'agent_auto', label: 'Agent (Auto)' },
  { value: 'agent_confirm', label: 'Agent (Confirm)' },
];

interface AgentModeSelectorProps {
  selectedMode: AgentMode;
  onModeChange: (mode: AgentMode) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Agent Mode Selector - Choose between Ask (read-only), Agent (Auto), or Agent
 * (Confirm)
 */
const AgentModeSelector: React.FC<AgentModeSelectorProps> = ({
  selectedMode,
  onModeChange,
  disabled,
  className = '',
}) => {
  const selectedOption = MODE_OPTIONS.find((opt) => opt.value === selectedMode);

  return (
    <div className={`agent-mode-selector-compact ${className}`}>
      <div className="d-flex align-items-center gap-2">
        <span className="mb-0 small text-muted">Mode:</span>
        <StylishNewSelect
          options={MODE_OPTIONS}
          value={selectedOption}
          onChange={(option) => onModeChange(option.value)}
          isDisabled={disabled}
          isSearchable={false}
          isClearable={false}
          style={{ minWidth: '180px' }}
        />
      </div>
    </div>
  );
};

export default AgentModeSelector;
